// extracted by mini-css-extract-plugin
export var columnItem = "_d2-3";
export var columnItemDraggable = "_d2-4";
export var dragHandle = "_d2-0";
export var dragHandleHovered = "_d2-1";
export var dropdown = "_d2-5";
export var dropdownContent = "_d2-7";
export var dropdownInner = "_d2-6";
export var filterDropdownHeader = "_d2-8";
export var icon = "_d2-2";
export var sectionDivider = "_d2-9";